var _ = require('lodash'),
  activeEvents = require('./eventObserver').active,
  cache = require('../models/cache'),
  CONST_EVENTS = require('../constants/events'),
  dfUtility = require('../utilities/deviceFingerprinterUtility'),
  logger = require('../libraries/logger'),
  log = logger.getLoggerInstance('Base.Main.GenericEvents'),
  jwtUtility = require('../utilities/jwtUtility'),
  passiveEvents = require('./eventObserver').passive,
  RSVP = require('rsvp'),
  uiManager = require('../libraries/uiManager');

var publicMethods = {
    /**
     * Setup any events that need to be listening when Songbird is loaded.
     */
    setupSubscriptions: function () {
      // Setup listeners for Cardinal.trigger
      activeEvents.subscribe(CONST_EVENTS.JWT_UPDATE, privateMethods.eventsHandlers.jwt.update);
      activeEvents.subscribe(CONST_EVENTS.ACCOUNT_NUMBER_UPDATE, privateMethods.eventsHandlers.accountNumber.update);
      activeEvents.subscribe(CONST_EVENTS.ORDER_UPDATE, privateMethods.eventsHandlers.order.update);
      activeEvents.subscribe(CONST_EVENTS.BIN_PROCESS, privateMethods.eventsHandlers.bin.process);

      // Setup any additional event hooks
      passiveEvents.subscribe(CONST_EVENTS.VALIDATED, function () {
        logger.flushLogs();
        uiManager.loader.events.hide();
        uiManager.plugin.teardown();
      });
    },
    /**
     * Public events that are subscribed to via 'Cardinal.on'
     */
    trigger: {
      /**
       * Events related to the Order Object management
       */
      order: {
        /**
         * Public listener to allow the merchant to update the cached order object
         */
        update: function () {
          return passiveEvents.publish(CONST_EVENTS.ORDER_UPDATE)
            .then(privateMethods.eventsHandlers.order.update);
        }
      },
      /**
       * Events related to Bin management
       */
      bin: {
        process: function (bin) {
          return privateMethods.eventsHandlers.bin.process(bin)
        }
      }
    }
  },
  privateMethods = {
    /**
     * Implementation of events that can be triggered externally via 'Cardinal.on' or internally.
     */
    eventsHandlers: {
      accountNumber: {
        update: function (accountNumber) {
          return new RSVP.Promise(function (resolve) {
              if (accountNumber !== undefined && typeof accountNumber === 'string' && accountNumber.length > 12) {
                if (cache.orderObject !== undefined) {
                  var order = cache.orderObject;
                  if (order.Consumer !== undefined && order.Consumer.Account !== undefined) {
                    log.info("Updating AccountNumber in cache");
                    order.Consumer.Account.AccountNumber = accountNumber;
                  } else {
                    log.info("Found existing order object without a Consumer object, creating Consumer and injecting AccountNumber");
                    order.Consumer = {
                      Account: {
                        AccountNumber: accountNumber
                      }
                    }
                  }
                } else {
                  log.warn("No order object found in cache, creating an empty one.");
                  cache.orderObject = {
                    Consumer: {
                      Account: {
                        AccountNumber: accountNumber
                      }
                    }
                  };
                }
                resolve();
              } else {
                resolve();
              }
            })
            .then(function () {
              return publicMethods.trigger.bin.process(accountNumber);
            })

        }
      },
      bin: {
        process: function (bin) {
          return new RSVP.Promise(function (resolve, reject) {
            try {
              var binAsNumber = parseInt(bin, 10);
              if(!_.isNaN(binAsNumber)){
                if (bin.length >= 6) {
                  log.debug('Updating bin value');
                  cache.bin = bin;
                  return dfUtility.shouldBinBeProfiled(bin)
                    .then(function (binNeedProfiling) {
                      if (binNeedProfiling) {
                        return dfUtility.renderCollectionFrame(cache.deviceFingerprinting.urls.profileBin);
                      }
                    })
                    .then(function () {
                      resolve();
                    })
                } else {
                  log.warn('Card numbers need to be at least 6 digits to profile');
                }
              } else {
                reject("Bin must be a numeric value");
              }
              
            } catch (error) {
              log.error('Failed to process bin event: ' + error);
              reject(error);
            }
          });
        }
      },
      jwt: {
        update: function (jwt) {
          log.debug('Updating Merchant JWT to: ' + jwt);
          cache.merchantJwt = jwt;
          jwtUtility.parseJwtForLogs(cache.merchantJwt);
        }
      },
      order: {
        /**
         * A method to update the local cache copy of the order object and return back what is currently stored in the cache
         * 
         * Note: This event has both passive and active triggers.
         * 
         * @param {Object} order The new order object to use
         * @returns {Object|undefined} The order object currently stored in cache. This will either be a copy of what was passed in or whatever was in the cache already. This value can be undefined is no order object has been set previously.
         */
        update: function (order) {
          // NEXTREV: Look into changing this function to a reject when the order arg isn't valid. Current event publishing only allows for resolves to chain properly
          return new RSVP.Promise(function (resolve) {
            // Normalize passive event data to active event data
            if (order && order instanceof Array) {
              // The event model allows for multiple listeners to provide return results. If we receive an array we have been provided the order via a subscriber. Its possible multiple subscribers exist and we may get more than 1 return value
              if (order.length > 1) {
                log.warn('More than 1 subcriber provided order objects. Only the first order object will be used.');
              }
              order = order.pop();
            }

            if (order !== undefined && order instanceof Object) {
              log.debug("Updating cached order object");
              cache.orderObject = order;
              resolve(order);
            } else {
              log.debug("Order object not updated, no valid order object found for event order.update, using existing copy in cache");
              resolve(cache.orderObject);
            }
          })
        }
      }
    }
  };

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./events/genericEvents.js
// module id = 56
// module chunks = 5